const actions = {
  SET_STATE: 'country/SET_STATE',

  LOAD_ALL: 'country/LOAD_ALL',
}

export default actions
